import { provinceData } from './index'
import { provinceOldData } from './oldAddress'

export const convertToNewAddress = (data, format=', ') => {
  const currentProvince = provinceData.find(
    item => +item?.value === +data.city_id,
  )
  const currentWard = currentProvince?.list?.find(
    item => +item?.value === +data.ward_id)
  const address = `${!!data?.address ? data?.address : ''}${!!currentWard?.name ? format + currentWard?.name : ''}${!!currentProvince?.name ? format + currentProvince?.name : ''}`
  return address
}

export const convertToOldAddress = (data, format=', ') => {
  const currentProvince = provinceOldData.find(
    item => +item?.value === +data.city_id,
  )
  
  let currentDistrict = null
  let currentWard = null
  
  if (+data.district_id > 0) {
    currentDistrict = currentProvince?.list?.find(
        item => +item?.value === +data.district_id
    )
    if (currentDistrict) {
      currentWard = currentDistrict?.list?.find(
          item => +item?.value === +data.ward_id
      )
    }
  } else {
    for (const district of currentProvince?.list || []) {
      const foundWard = district?.list?.find(
          item => +item?.value === +data.ward_id
      )
      if (foundWard) {
        currentDistrict = district
        currentWard = foundWard
        break
      }
    }
  }
  
  const address = `${!!data?.address ? data?.address : ''}${!!currentWard?.name ? format + currentWard?.name : ''}${!!currentDistrict?.name ? format + currentDistrict?.name : ''}${!!currentProvince?.name ? format + currentProvince?.name : ''}`
  return address
}

export const convertToNewArea = (data, format=', ') => {
  const currentProvince = provinceData.find(
      item => +item?.value === +data.city_id,
  )
  const currentWard = currentProvince?.list?.find(
      item => +item?.value === +data.ward_id)
  const area = `${!!currentProvince?.name ?  currentProvince?.name : ''}${!!currentWard?.name ? format + currentWard?.name : ''}`
  return area
}

export const convertToOldArea = (data, format=', ') => {
  const currentProvince = provinceOldData.find(
      item => +item?.value === +data.city_id,
  )
  
  let currentDistrict = null
  let currentWard = null
  
  if (+data.district_id > 0) {
    currentDistrict = currentProvince?.list?.find(
        item => +item?.value === +data.district_id
    )
    if (currentDistrict) {
      currentWard = currentDistrict?.list?.find(
          item => +item?.value === +data.ward_id
      )
    }
  } else {
    for (const district of currentProvince?.list || []) {
      const foundWard = district?.list?.find(
          item => +item?.value === +data.ward_id
      )
      if (foundWard) {
        currentDistrict = district
        currentWard = foundWard
        break
      }
    }
  }
  
  const area = `${!!currentProvince?.name ? currentProvince?.name : ''}${!!currentDistrict?.name ? format + currentDistrict?.name : ''}${!!currentWard?.name ? format + currentWard?.name : ''}`
  return area
}

